import { computed, inject, Injectable } from '@angular/core';
import { mapDashboardAttentionMatrix } from '../home/staff-order-home-stats.util';
import { StaffDashboardService } from '../home/staff-dashboard.service';

@Injectable({ providedIn: 'root' })
export class StaffOrderAttentionService {
  readonly #dashboard = inject(StaffDashboardService);

  readonly stats = computed(() => {
    const data = this.#dashboard.data();
    if (!data) {
      return null;
    }

    return mapDashboardAttentionMatrix(
      data.orders_attention_matrix ?? [],
      data.summary.orders_attention,
    );
  });

  readonly loading = computed(() => this.#dashboard.loading());
  readonly accessDenied = computed(() => this.#dashboard.accessDenied());
  readonly error = computed(() => this.#dashboard.error());

  readonly attentionTotal = computed(
    () => this.#dashboard.data()?.summary.orders_attention ?? 0,
  );

  ensureLoaded(): void {
    this.#dashboard.ensureLoaded();
  }

  refresh(): void {
    this.#dashboard.refresh();
  }
}
